import Footer from '../footer';

const FooterScrolling = () => <Footer />;

export default FooterScrolling;
